// Auto-generated file - do not edit manually
export const useVersion = () => {
  return {
    version: '2.4.46',
    buildTime: '2026-09-01T18:43:20.826Z',
    buildTimestamp: 1788288200826,
    gitCommit: '5ed29bda',
    buildNumber: '260901.2143',
    environment: 'production',
    formattedBuildTime: '01.09.2026, 21:43'
  }
}